"use strict";
import Api from "../../api/api";
import Auth from "../../util/auth";
export class CarrierInvoice {
  constructor(invoice, loadState) {
    this.invoice = invoice;
    this.loadState = loadState;
  }
  isApproved() {
    return this.invoice.state === "approved";
  }
  isPayableApproved() {
    return this.invoice.state === "approved" || this.invoice.state === "partial_approved";
  }
  unapprovalPermissions() {
    const settings = Api.Account.currentSettings() || {};
    const adminCanUnapprove = settings["can_unapprove_invoices"];
    const userCanUnapprove = adminCanUnapprove && Auth._currentUser.admin;
    return {
      userCanUnapprove,
      adminCanUnapprove,
      unapprovalsNotAllowed: !adminCanUnapprove
    };
  }
  unapprovingPayableAllowed() {
    const settings = Api.Account.currentSettings() || {};
    const blockedStatuses = settings["carrier_payable_block_unapprove_statuses"] || [];
    const payable = this.carrierPayable();
    return !(payable && blockedStatuses.includes(payable.status));
  }
  carrierPayable() {
    return this.invoice.tms_carrier_payable_id && this.loadState.load.load.tms_carrier_payables.find((payable) => payable.id === this.invoice.tms_carrier_payable_id);
  }
}
